/* eslint-disable import/prefer-default-export */
import React from 'react';
import {Route, IndexRedirect} from 'react-router';
import {loadable} from 'lib/loadable/route';
import {requireSessionWithLoginPrompt} from 'lib/decorators/requireSession';

const Marketplace = loadable(() => import('./Marketplace.react'));
const CheckoutConfirmation = loadable(() => import('./Checkout/Confirmation/Confirmation.react'));

const MarketplaceRoutes = (
  <Route name='marketplace' path='/marketplace' title='Marketplace | Albert.io'>
    <IndexRedirect to='subjects' />
    <Route component={requireSessionWithLoginPrompt()(Marketplace)} path='subjects' />
    <Route component={requireSessionWithLoginPrompt()(CheckoutConfirmation)} path='confirmation' />
  </Route>
);

export {MarketplaceRoutes};
